import {
  GENDER,
  IDENTITY_DOCUMENT_TYPE,
  IDENTITY_TYPE,
  IS_LOCAL,
  NEED_STUDENT_VISA,
  PROVINCE,
} from './constants';
import { PAGE_TEXT } from './lang';
import { type SelectOption } from '../../../components';

export const genderOptions: SelectOption[] = [
  {
    value: GENDER.FEMALE,
    label: PAGE_TEXT.OPTIONS_LABEL.GENDER.FEMALE,
  },
  {
    value: GENDER.MALE,
    label: PAGE_TEXT.OPTIONS_LABEL.GENDER.MALE,
  },
];

export const identityDocumentTypeOptions: SelectOption[] = [
  {
    value: IDENTITY_DOCUMENT_TYPE.HK_ID,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_DOCUMENT_TYPE.HK_ID,
  },
  {
    value: IDENTITY_DOCUMENT_TYPE.MAINLAND_ID,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_DOCUMENT_TYPE.MAINLAND_ID,
  },
  {
    value: IDENTITY_DOCUMENT_TYPE.PASSPORT,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_DOCUMENT_TYPE.PASSPORT,
  },
];

export const identityTypeFullOptions: SelectOption[] = [
  {
    value: IDENTITY_TYPE.HKID_PERM,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.HKID_PERM,
  },
  {
    value: IDENTITY_TYPE.STUDENT_VISA,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.STUDENT_VISA,
  },
  {
    value: IDENTITY_TYPE.IANG,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.IANG,
  },
  {
    value: IDENTITY_TYPE.WORK_VISA,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.WORK_VISA,
  },

  {
    value: IDENTITY_TYPE.TTPS,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.TTPS,
  },
  {
    value: IDENTITY_TYPE.HKID_RIGHT_TO_LAND,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.HKID_RIGHT_TO_LAND,
  },

  {
    value: IDENTITY_TYPE.DEPENDANT_VISA_UNDER_18,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.DEPENDANT_VISA_UNDER_18,
  },
  {
    value: IDENTITY_TYPE.DEPENDANT_VISA_ABOVE_18,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.DEPENDANT_VISA_ABOVE_18,
  },

  {
    value: IDENTITY_TYPE.OTHER_VISA,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE_FULL_OPTIONS.OTHER_VISA,
  },
];

export const localTypeOptions: SelectOption[] = [
  {
    value: IS_LOCAL.LOCAL,
    label: PAGE_TEXT.OPTIONS_LABEL.IS_LOCAL.LOCAL,
  },
  {
    value: IS_LOCAL.NON_LOCAL,
    label: PAGE_TEXT.OPTIONS_LABEL.IS_LOCAL.NON_LOCAL,
  },
];

export const needStudentVisaOptions: SelectOption[] = [
  {
    value: NEED_STUDENT_VISA.YES,
    label: PAGE_TEXT.OPTIONS_LABEL.NEED_STUDENT_VISA.YES,
  },
  {
    value: NEED_STUDENT_VISA.NO,
    label: PAGE_TEXT.OPTIONS_LABEL.NEED_STUDENT_VISA.NO,
  },
];

export const dependantVisaOptions: SelectOption[] = [
  {
    value: IDENTITY_TYPE.DEPENDANT_VISA_ABOVE_18,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.DEPENDANT_VISA_ABOVE_18,
  },
  {
    value: IDENTITY_TYPE.DEPENDANT_VISA_UNDER_18,
    label: PAGE_TEXT.OPTIONS_LABEL.IDENTITY_TYPE.DEPENDANT_VISA_BELOW_18,
  },
];

export const provinceOptions: SelectOption[] = [
  { value: PROVINCE.AN_HUI, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.AN_HUI },
  {
    value: PROVINCE.BEI_JING,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.BEI_JING,
  },
  {
    value: PROVINCE.CHONG_QING,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.CHONG_QING,
  },
  { value: PROVINCE.FU_JIAN, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.FU_JIAN },
  { value: PROVINCE.GAN_SU, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.GAN_SU },
  {
    value: PROVINCE.GUANG_DONG,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.GUANG_DONG,
  },
  {
    value: PROVINCE.GUANG_XI,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.GUANG_XI,
  },
  {
    value: PROVINCE.GUI_ZHOU,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.GUI_ZHOU,
  },
  { value: PROVINCE.HAI_NAN, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.HAI_NAN },
  {
    value: PROVINCE.HEI_LONG_JIANG,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.HEI_LONG_JIANG,
  },
  { value: PROVINCE.HE_BEI, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.HE_BEI },
  { value: PROVINCE.HE_NAN, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.HE_NAN },
  { value: PROVINCE.HU_BEI, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.HU_BEI },
  { value: PROVINCE.HU_NAN, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.HU_NAN },
  {
    value: PROVINCE.JIANG_SU,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.JIANG_SU,
  },
  {
    value: PROVINCE.JIANG_XI,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.JIANG_XI,
  },
  { value: PROVINCE.JI_LIN, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.JI_LIN },
  {
    value: PROVINCE.LIAO_NING,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.LIAO_NING,
  },
  {
    value: PROVINCE.NEI_MONGOL,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.NEI_MONGOL,
  },
  {
    value: PROVINCE.NING_XIA,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.NING_XIA,
  },
  {
    value: PROVINCE.QING_HAI,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.QING_HAI,
  },
  {
    value: PROVINCE.SHAAN_XI,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.SHAAN_XI,
  },
  {
    value: PROVINCE.SHANG_HAI,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.SHANG_HAI,
  },
  {
    value: PROVINCE.SHAN_DONG,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.SHAN_DONG,
  },
  { value: PROVINCE.SHAN_XI, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.SHAN_XI },
  {
    value: PROVINCE.SI_CHUAN,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.SI_CHUAN,
  },
  {
    value: PROVINCE.TIAN_JIN,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.TIAN_JIN,
  },
  {
    value: PROVINCE.XIN_JIANG,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.XIN_JIANG,
  },
  { value: PROVINCE.XI_ZANG, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.XI_ZANG },
  { value: PROVINCE.YUN_NAN, label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.YUN_NAN },
  {
    value: PROVINCE.ZHE_JIANG,
    label: PAGE_TEXT.OPTIONS_LABEL.PROVINCE.ZHE_JIANG,
  },
];
